import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';

const SaleEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const recordId = useParams(); // Assuming you're using React Router
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const [selectedTable, setSelectedTable] = useState("");
    const [dropdownTableOptions, setDropdownTableOptions] = useState([]);
    const [TableOptions, setTableOptions] = useState([]);

    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();

    useEffect(() => {
        fetchDropdownTableOptions();
    }, []);


    const fetchDropdownTableOptions = () => {
        fetchData('TableNameApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownTableOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Table dropdown options:', error);
            });
    };

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState({
        CompanyId: '',
        InvoiceDate: '',
        InvoiceTime: '',
        InvoiceNumber: '',
        TableId: '',
        KOTId: '',
        Amount: '',
        DiscountAmount: '',
        DiscountPer: '',
        NetAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        RoundOff: '',
        TotalAmount: '',
        PaymentType: '',
        FinYear: '',
        isSubmit: false,
        TableText: '',
        ModifiedBy: userId,
        PreviousTotalAmount: '',
        PackingCharge: '',
        PreviousPaymentType: '',
    });
    const [itemdata, setData] = useState([]);


    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();

        // Pad the month and day with leading zeros if needed
        month = month.length === 1 ? `0${month}` : month;
        day = day.length === 1 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    };
    const formatTimeForInput = (timeString) => {
        const time = new Date(`1970-01-01T${timeString}`);
        const hours = time.getHours().toString().padStart(2, '0');
        const minutes = time.getMinutes().toString().padStart(2, '0');
        const seconds = time.getSeconds().toString().padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`;
    };

    useEffect(() => {
        fetchData('SaleApi', `/SaleDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setData(response.response_data.SaleDetails);
                    setSelectedTable(response.response_data.Sale.TableId);
                }

                setFormData((prevData) => ({
                    ...prevData,
                    ModifiedBy: userId,
                }));

            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const [newRecordData, setNewRecordData] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    // For Item
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemOptions, setItemOptions] = useState([]);
    const [itemdetails, setItemDetails] = useState([]);

    useEffect(() => {

        const fetchItemData = async () => {
            try {
                const response = await fetchData('SaleApi', `/Item/${companyId}`, token);
                const responseData = response.response_data;

                const options = responseData.map((item) => ({
                    label: item.Name,
                    value: item.Id,
                }));

                setItemOptions(options);
                setItemDetails(responseData);
            } catch (error) {
                console.error('Error fetching item data:', error);
            }
        };

        fetchItemData();
    }, [companyId, token]);



    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setNewRecordData({
            ...newRecordData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });

        // Use Array.prototype.find() to find the rate
        const selectedItemId = selectedOption ? selectedOption.value : '';


        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {
            // Update the rate in the modal data
            setNewRecordData({
                ...newRecordData,
                Rate: selectedItemDetail.Rate, // Assuming Rate is a number
                GSTRate: formData.GstNotApplicable ? 0 : selectedItemDetail.GSTRate,
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
            });
        } else {
            // Handle the case where the item detail is not found
            setNewRecordData({
                ...newRecordData,
                Rate: '0',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
            });
        }
    };



    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const discountPercentage = parseFloat(formData.discountPercentage) || 0;
        // Update the new record data
        setNewRecordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        const GstNotApplicable = formData.GstNotApplicable ? formData.GstNotApplicable : false;
        // If the input is for quantity, calculate the amount
        if (name === 'Quantity') {
            const quantity = parseFloat(value) || 0;
            const rate = parseFloat(newRecordData.Rate) || 0;
            const amount = (quantity * rate).toFixed(2);

            const discountAmount = (amount * discountPercentage) / 100;
            const netAmount = (amount - discountAmount).toFixed(2);
            let gstrate = newRecordData.GSTRate;
            if (GstNotApplicable) {
                gstrate = 0;
            }

            const cgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
            const sgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
            const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

            // Update the new record data with the calculated amount
            setNewRecordData((prevData) => ({
                ...prevData,
                Amount: amount,
                DiscountPer: discountPercentage,
                DiscountAmount: discountAmount.toFixed(2),
                NetAmount: netAmount,
                CGSTAmount: cgstAmount,
                SGSTAmount: sgstAmount,
                TotalAmount: totalAmount,
                GSTRate: gstrate,
            }));
        }
    };


    const addRecord = () => {

        if (!newRecordData.ItemName && !newRecordData.Quantity) {
            return;
        }
        const updatedItemData = [...itemdata, newRecordData];
        setData(updatedItemData);
        setNewRecordData([]);
        toggleModal();

        // Update the totals based on the updatedItemData
        const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
        const cgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
        const sgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
        const igstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount) || 0, 0);
        const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
        const additionalDiscount = parseFloat(formData.AdditionalDiscount) || 0;

        totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount, additionalDiscount);
    };

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        const GstNotApplicable = formData.GstNotApplicable || false;

        setFormData((prevData) => {
            let updatedData = {
                ...prevData,
                [name]: type === 'checkbox' ? !prevData[name] : value,
                ModifiedBy: userId
            };
            const totalAmount = parseFloat(updatedData.TotalAmount) || 0;
            if (name === "PaymentType") {

                var ptype = value;
                if (ptype === "1") {
                    updatedData.CashAmount = totalAmount;
                    updatedData.CardAmount = 0;
                    updatedData.UPIAmount = 0;
                }
                else if (ptype === "2") {
                    updatedData.CardAmount = totalAmount;
                    updatedData.CashAmount = 0;
                    updatedData.UPIAmount = 0;
                }
                else if (ptype === "3") {
                    updatedData.UPIAmount = totalAmount;
                    updatedData.CashAmount = 0;
                    updatedData.CardAmount = 0;
                }

            }
            // Convert numeric values

            let cashAmount = parseFloat(updatedData.CashAmount) || 0;
            let cardAmount = parseFloat(updatedData.CardAmount) || 0;
            let upiAmount = parseFloat(updatedData.UPIAmount) || 0;

            // Handle payment method constraints
            if (name === "CashAmount") {
                const maxCashAmount = totalAmount - (cardAmount + upiAmount);
                updatedData.CashAmount = Math.min(cashAmount, maxCashAmount).toFixed(2);
            }
            else if (name === "CardAmount") {
                const maxCardAmount = totalAmount - (cashAmount + upiAmount);
                updatedData.CardAmount = Math.min(cardAmount, maxCardAmount).toFixed(2);
            }
            else if (name === "UPIAmount") {
                const maxUpiAmount = totalAmount - (cashAmount + cardAmount);
                updatedData.UPIAmount = Math.min(upiAmount, maxUpiAmount).toFixed(2);
            }

            // Handle discount calculations
            if (name === "DiscountPer" || name === "DiscountAmount") {
                const discountPercentage = name === "DiscountPer" ? (parseFloat(value) || 0) : ((parseFloat(value) || 0) / parseFloat(formData.Amount || 1)) * 100;
                const additionalDiscount = parseFloat(updatedData.AdditionalDiscount) || 0;

                updatedData.DiscountPer = discountPercentage.toFixed(2);

                const updatedItemData = itemdata.map((item) => {
                    const amount = parseFloat(item.Amount) || 0;
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    let gstrate = GstNotApplicable ? 0 : item.GSTRate;

                    const cgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const sgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                    return {
                        ...item,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: cgstAmount,
                        SGSTAmount: sgstAmount,
                        TotalAmount: totalAmount,
                        GSTRate: gstrate
                    };
                });

                setData(updatedItemData);

                // Recalculate totals
                const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
                const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
                const cgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
                const sgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
                const igstAmount = updatedItemData.reduce((sum, item) => sum + (parseFloat(item.IGSTAmount) || 0), 0);
                const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

                totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount, additionalDiscount);
            }

            // Handle additional discount updates
            if (name === "AdditionalDiscount") {
                const additionalDiscount = parseFloat(value) || 0;

                const invAmount = itemdata.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
                const netAmount = itemdata.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
                const cgstAmount = itemdata.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
                const sgstAmount = itemdata.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
                const igstAmount = itemdata.reduce((sum, item) => sum + (parseFloat(item.IGSTAmount) || 0), 0);
                const discAmount = itemdata.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

                totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount, additionalDiscount);
            }

            return updatedData;
        });
    };


    const handleSubmit = (event) => {
        event.preventDefault();


        if (parseFloat(formData.CashAmount) + parseFloat(formData.CardAmount) + parseFloat(formData.UPIAmount) !== parseFloat(formData.TotalAmount)) {
            setErrorMessage("The sum of Cash, Card, and UPI amounts must equal the Total Amount.");
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: itemdata
        };

        // Validate form data here if needed

        updateData('SaleApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/SaleIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...itemdata];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setData(updatedRecords); // Update the state to reflect the removed record 

            let invAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            let netAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
            let cgstAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            let sgstAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            let igstAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.IGSTAmount) || 0, 0);
            let discAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

            totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount);
        }

    };

    const totalCalculation = (invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount, additionalDiscount) => {
        const packingCharge = parseFloat(formData.PackingCharge) || 0;
        let amount = parseFloat(invAmount);
        let netamount = parseFloat(netAmount);
        let netAmt = netAmount + parseFloat(cgstAmount) + parseFloat(sgstAmount) + parseFloat(igstAmount) + packingCharge;
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmount = (netAmt + roundOffValue - additionalDiscount).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            Amount: amount.toFixed(2),
            NetAmount: netamount.toFixed(2),
            TotalAmount: totalAmount,
            DiscountAmount: discAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            CGSTAmount: cgstAmount.toFixed(2),
            SGSTAmount: sgstAmount.toFixed(2),
            IGSTAmount: igstAmount.toFixed(2),
            ModifiedBy: userId,
        }));
    };

    const handleCalculation = (e, index) => {
        const { name, value } = e.target;
        const discountPercentage = parseFloat(formData.DiscountPer) || 0;
        const GstNotApplicable = formData.GstNotApplicable ? formData.GstNotApplicable : false;

        const updatedItemData = itemdata.map((item, i) => {
            if (i === index) {
                if (name === 'Quantity') {
                    const quantity = parseFloat(value) || 0;
                    const rate = parseFloat(item.Rate) || 0;
                    const amount = (quantity * rate).toFixed(2);
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    let gstrate = item.GSTRate;
                    if (GstNotApplicable) {
                        gstrate = 0;
                    }

                    const cgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const sgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                    return {
                        ...item,
                        Quantity: quantity,
                        Amount: amount,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: cgstAmount,
                        SGSTAmount: sgstAmount,
                        TotalAmount: totalAmount,
                        GSTRate: gstrate,
                    };
                } else if (name === 'Rate') {
                    const rate = parseFloat(value) || 0;
                    const quantity = parseFloat(item.Quantity) || 0;
                    const amount = (quantity * rate).toFixed(2);
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    let gstrate = item.GSTRate;
                    if (GstNotApplicable) {
                        gstrate = 0;
                    }

                    const cgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const sgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                    return {
                        ...item,
                        Rate: rate,
                        Amount: amount,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: cgstAmount,
                        SGSTAmount: sgstAmount,
                        TotalAmount: totalAmount,
                        GSTRate: gstrate,
                    };
                }
            }
            return item;
        });

        setData(updatedItemData);

        // Update the totals based on the updatedItemData
        const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
        const cgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
        const sgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
        const igstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount) || 0, 0);
        const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
        const additionalDiscount = parseFloat(formData.AdditionalDiscount) || 0;

        totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount, additionalDiscount);
    };



    return (
        <Fragment>
            <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>

                <style>
                    {`
                        .radio-group label {
                            display: inline-block;
                            margin-right: 10px;
                        }
                        
                        .radio-group input {
                            transform: scale(1.5); 
                            margin-right: 5px;
                            margin-top:10px;
                        }
                    
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> SALE - EDIT</h6>
                    <Button
                        variant="contained"
                        style={{ marginLeft: '8px', backgroundColor: '#FFCDB2', color: 'white', height: '25px' }}
                        onClick={toggleModal}
                    >
                        ADD RECORD
                    </Button>
                    <Button
                        variant="contained"
                        style={{ marginLeft: '8px', backgroundColor: 'AEEA94', color: 'white', height: '25px' }}
                        onClick={handleSubmit}
                    >
                        UPDATE
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to="/SaleIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', height: '25px' }}
                    >
                        CANCEL
                    </Button>
                </div>


                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-5px' }}>
                    <div className="w-full mb-4 flex">

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Invoice No
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.InvoiceNumber}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Invoice No"
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Invoice Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.InvoiceDate)}
                                onChange={handleChange}
                                type="date"
                                placeholder="Enter Invoice Date"
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Invoice Time
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatTimeForInput(formData.InvoiceTime)}
                                onChange={handleChange}
                                type="Time"
                                placeholder="Enter Invoice Time"
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Table Name
                                <span className="text-red-500">*</span>
                            </label>

                            <select
                                className={`custom-select ${selectedTable ? 'fade-in' : 'fade-in'}`}
                                style={{ height: '35px' }}
                                value={selectedTable}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setSelectedTable(selectedValue);

                                    // Find the selected table's record in dropdownTableOptions
                                    const selectedTableRecord = dropdownTableOptions.find(category => category.Id === selectedValue);

                                    // Extract GstNotApplicable value from the selected table's record
                                    const gstNotApplicable = selectedTableRecord ? selectedTableRecord.GstNotApplicable : false;

                                    // Update formData with TableId and GstNotApplicable
                                    setFormData((prevFormData) => ({
                                        ...prevFormData,
                                        TableId: selectedValue,
                                        GstNotApplicable: gstNotApplicable,
                                    }));
                                }}
                            >
                                <option value="">Table</option>
                                {dropdownTableOptions.map((category) => (
                                    <option key={category.Id} value={category.Id}>
                                        {category.Name}
                                    </option>
                                ))}
                            </select>

                        </div>

                        <div className="w-1/5 radio-group" style={{ marginLeft: '10px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Payment Type
                                <span className="text-red-500">*</span>
                            </label>
                            <div className="flex items-center text-black">
                                <label className="mr-2 text-black">
                                    <input
                                        type="radio"
                                        name="PaymentType"
                                        value="1"
                                        checked={formData.PaymentType.toString() === '1'}
                                        onChange={handleChange}
                                    />
                                    Cash
                                </label>
                                <label className="mr-2 text-black">
                                    <input
                                        type="radio"
                                        name="PaymentType"
                                        value="2"
                                        checked={formData.PaymentType.toString() === '2'}
                                        onChange={handleChange}
                                    />
                                    Card
                                </label>
                                <label className='text-black'>
                                    <input
                                        type="radio"
                                        name="PaymentType"
                                        value="3"
                                        checked={formData.PaymentType.toString() === '3'}
                                        onChange={handleChange}
                                    />
                                    UPI
                                </label>
                            </div>

                        </div>
                    </div>
                    <div className="w-full mb-4 flex" style={{ marginTop: '-1.50%' }}>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.Amount).toFixed(2)}
                                onChange={handleChange}
                                type="number"
                                placeholder="Enter Amount"
                                readOnly
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Discount %
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.DiscountPer).toFixed(2)}
                                onChange={handleChange}
                                name='DiscountPer'
                                type="number"
                                placeholder="Enter Discount %"
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Discount Amt
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.DiscountAmount).toFixed(2)}
                                onChange={handleChange}
                                name='DiscountAmount'
                                type="number"
                                placeholder="Enter Discount Amount"
                                readOnly
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Addt'l. Discount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.AdditionalDiscount).toFixed(2)}
                                onChange={handleChange}
                                name='AdditionalDiscount'
                                type="number"
                                placeholder="Enter Additional Discount"
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>


                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Net Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.NetAmount).toFixed(2)}
                                name='NetAmount'
                                onChange={handleChange}
                                type="number"
                                placeholder="Enter Net Amount"
                                readOnly
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                CGST
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.CGSTAmount).toFixed(2)}
                                onChange={handleChange}
                                name='CGSTAmount'
                                type="number"
                                placeholder="Enter CSGT"
                                readOnly
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                SGST
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.SGSTAmount).toFixed(2)}
                                onChange={handleChange}
                                name='SGSTAmount'
                                type="number"
                                placeholder="Enter SGST"
                                readOnly
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                IGST
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.IGSTAmount).toFixed(2)}
                                onChange={handleChange}
                                name='IGSTAmount'
                                type="number"
                                placeholder="Enter IGST"
                                readOnly
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                    </div>

                    <div className="w-full mb-4 flex" style={{ marginTop: '-1.30%' }}>

                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Packing Charge
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.PackingCharge).toFixed(2)}
                                onChange={handleChange}
                                type="number"
                                placeholder="Enter Packing Charge"
                                name='PackingCharge'
                                readOnly
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>

                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Round Off
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.RoundOff).toFixed(2)}
                                onChange={handleChange}
                                type="number"
                                placeholder="Enter Round Off"
                                readOnly
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>

                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Total Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.TotalAmount).toFixed(2)}
                                onChange={handleChange}
                                type="number"
                                placeholder="Enter Total Amount"
                                readOnly
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Cash
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.CashAmount).toFixed(2)}
                                onChange={handleChange}
                                type="number"
                                placeholder="Enter Cash Amount"
                                name='CashAmount'
                                style={{ fontWeight: 'bold', color: 'red' }}
                            />
                        </div>

                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Card
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.CardAmount).toFixed(2)}
                                onChange={handleChange}
                                type="number"
                                placeholder="Enter Card Amount"
                                name='CardAmount'
                                style={{ fontWeight: 'bold', color: 'red' }}
                            />
                        </div>

                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                UPI
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.UPIAmount).toFixed(2)}
                                onChange={handleChange}
                                type="number"
                                placeholder="Enter UPI Amount"
                                name='UPIAmount'
                                style={{ fontWeight: 'bold', color: 'red' }}
                            />
                        </div>
                    </div>

                </div >
                <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>

                    <div className="w-full mb-4 flex">
                        {isModalOpen && (
                            <div className="fixed inset-0 flex items-center justify-center z-10">
                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px' }}>

                                    <h6 style={{ textAlign: 'center', fontFamily: 'cursive', color: 'darkmagenta' }}>ITEMS</h6>
                                    <div className="w-full mb-4 flex">
                                        <div className="w-4/5 mr-4">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-medium mb-2" htmlFor="name">
                                                Item Name
                                                <span className="text-red-500">*</span>
                                            </label>
                                            <Select
                                                options={itemOptions}
                                                value={selectedItem}
                                                onChange={handleItemSelect}
                                                placeholder="Select Item"
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="ContactNumber1">
                                                Quantity
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Quantity"
                                                placeholder="Enter Quantity"
                                                value={newRecordData.Quantity}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full mb-2 flex">

                                        <Button
                                            variant="contained"
                                            style={{ marginLeft: '8px', backgroundColor: 'AEEA94', color: 'white', height: '25px' }}
                                            onClick={addRecord}
                                        >
                                            UPDATE
                                        </Button>

                                        <Button
                                            variant="contained"
                                            color="error"
                                            onClick={toggleModal}
                                            className="linkcolor"
                                            style={{ marginLeft: '8px', height: '25px' }}
                                        >
                                            CANCEL
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="w-full mb-4 flex" style={{ marginTop: '-2.50%' }}>
                        <div className="w-full mb-4 flex">
                            <TableContainer component={Paper}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th style={{ padding: '4px' }}>Item Name</th>
                                            <th style={{ padding: '4px', textAlign: 'center' }}>Quantity</th>
                                            <th style={{ padding: '4px', textAlign: 'center' }}>Rate</th>
                                            <th style={{ padding: '4px', textAlign: 'center' }}>Disc %</th>
                                            <th style={{ padding: '4px', textAlign: 'center' }}>Total</th>
                                            <th style={{ padding: '4px' }}>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {itemdata.map((invdetail, index) => (
                                            <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                <td style={{ padding: '4px', fontSize: '14px', width: '60%' }}>{invdetail.ItemName}</td>
                                                <td style={{ padding: '4px', fontSize: '14px', width: '10%', textAlign: 'center', backgroundColor: invdetail.Quantity > invdetail.BalStock ? '#ffcccc' : 'inherit' }}>
                                                    <input
                                                        type="number"
                                                        value={invdetail.Quantity}
                                                        onChange={(e) => handleCalculation(e, index)}
                                                        style={{ maxWidth: '120px', textAlign: 'right', height: '30px', fontWeight: 'bold' }}
                                                        name="Quantity"
                                                    />
                                                </td>
                                                <td style={{ padding: '4px', fontSize: '14px', width: '10%', textAlign: 'center', fontWeight: 'bold' }}>{invdetail.Rate}</td>
                                                <td style={{ padding: '4px', fontSize: '14px', width: '10%', textAlign: 'center', fontWeight: 'bold' }}>{invdetail.DiscountPer}</td>
                                                <td style={{ padding: '4px', fontSize: '14px', width: '10%', textAlign: 'center', fontWeight: 'bold' }}>
                                                    {typeof invdetail.TotalAmount === 'number' ? invdetail.TotalAmount.toFixed(2) : invdetail.TotalAmount}
                                                </td>

                                                <td style={{ padding: '4px', marginTop: '-15px', width: '15%' }}>

                                                    {hasDeleteTransactionPermission && (
                                                        <IconButton style={{ padding: '4px', marginTop: '-5px' }} onClick={() => removeRecord(index)}>
                                                            <DeleteIcon style={{ color: 'red' }} />
                                                        </IconButton>
                                                    )}

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </TableContainer>
                        </div>
                    </div>
                </div >
            </div >
        </Fragment >

    );
};

export default SaleEdit;
